module.exports = __webpack_public_path__ + "img/小程序.7121273f.svg";